<template>
  <div class="view-wrapper view-wrapper-with-header">
    <van-nav-bar title="支付结果" left-arrow @click-left="$router.push('/order/0')" class="fixed-top" />
    <div class="info">
      <div v-if="isSuccess">
        <van-icon name="passed" class="icon success" />
        <div class="text">支付成功</div>
      </div>
      <div v-else>
        <van-icon name="warning-o" class="icon fail" />
        <div class="text">支付失败</div>
      </div>
    </div>
    <div class="btns">
      <div>
        <van-button type="primary" round to="/order/0">返回订单列表</van-button>
      </div>
      <div>
        <!-- <van-button type="primary" round>返回首页</van-button> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Callback",
  activated() {
    this.orderNo = this.$route.query.out_trade_no;
    this.payStatus = this.$route.query.trade_status;
    if(this.payStatus===""){
        this.$router.push("/order/0");
    }
  },
  computed: {
    isSuccess() {
      return this.payStatus === "TRADE_SUCCESS";
    }
  },
  data() {
    return {
      orderNo: "",
      payStatus: ""
    };
  }
};
</script>

<style lang="less" scoped>
.view-wrapper {
  min-height: 100%;
  background: #fff;
}
.info {
  text-align: center;
  margin-top: 50px;
  padding: 40px 15px 20px 15px;
}
.info .icon {
  font-size: 100px;
}
.info .icon.success {
  color: #07c160;
}
.info .icon.fail {
  color: #f44;
}
.info .text {
  font-size: 20px;
}
.btns {
  padding: 10px 15px;
  text-align: center;
}
.btns button {
  width: 60%;
}
</style>